







import Vue from 'vue'
import router from '@/router';
import { store } from '@/store';

export default Vue.extend({
    name: 'spectras',
    data() {
        return {
            columns: [{
                name: 'name',
                label: 'Name',
                sortable: true,
                field: 'name'
            }, {
                name: 'precursormass',
                field: 'precursormass',
                sortable: true,
                label: 'Precursor Mass'
            }, {
                name: 'parentmass',
                field: 'parentmass',
                sortable: true,
                label: 'Parent Mass'
            }],
            pagination: {
                sortBy: 'name',
                rowsPerPage: 25
            }
        }
    },
    computed: {
        data() {
            const docs = store.state.dataset.doc_metadata;
            return Object.entries(docs).map(([k, v]) => {
                return {id: k, ...v, name: `${v.filename}:${v.scans}`};
            })
        }
    },
    methods: {
        gotoSpectra: function(_event: any, {id}: any) {
            router.push({name:'spectra', params: {id}})
        }
    }
})
